module.exports = __webpack_public_path__ + "media/images/icons/ic-logout-e20225d83c8b73da391dc3e614f2dbc2.svg";